import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const KSeFInboxPage = lazy(
  () => import("../../../../components/WMS/KSeF/KSeFInboxPage.tsx"),
)

export const Route = createFileRoute("/_layout/WMS/ksef/")({
  component: KSeFInboxRoute,
})

function KSeFInboxRoute() {
  return (
    <LazyRoutePage>
      <KSeFInboxPage />
    </LazyRoutePage>
  )
}
